import React from "react";
import FileCrossIcon from "../../assets/svg/file-cross-icon";
import { P2TextDescription } from "react-bootstrap-common-script";
interface ConfettiBannerProps
  extends React.HtmlHTMLAttributes<HTMLDivElement> {}

function ConfettiBanner({ ...props }: ConfettiBannerProps) {
  return (
    <div style={{ ...props.style }} className="d-flex justify-content-center align-items-center gap-2">
      <FileCrossIcon />
      <P2TextDescription
        size="20px"
        color="#333"
        description_margin="0"
        description_size="1rem"
        description={
          "Great news! You do not need to submit any new documents at this time."
        }
      />
    </div>
  );
}

export default ConfettiBanner;
